import * as React from 'react';
import classNames from 'classnames';
import Image from '../../../Image/viewer/Image';
import { IMatrixGalleryItemProps } from '../MatrixGalleryItem.types';
import ItemClickActionWrapper from '../../commons/viewer/ItemClickActionWrapper/ItemClickActionWrapper';
import Panel from './Panel';
import ImageSizer from './ImageSizer';

const MatrixGalleryItem: React.FC<IMatrixGalleryItemProps> = props => {
  const {
    dataId,
    title,
    description,
    link,
    image,
    skinsStyle,
    extraClassNames,
    imageOnClickAction,
    openImageZoom = () => {},
    itemClickHandler = () => {},
    translate,
    isFocused,
    isFitMode,
  } = props;

  const openImageZoomCallback = React.useCallback(() => openImageZoom(dataId), [
    dataId,
    openImageZoom,
  ]);

  return (
    <div
      className={classNames(skinsStyle.root, extraClassNames.root, {
        [skinsStyle.fitMode]: isFitMode,
      })}
      onClick={itemClickHandler}
    >
      <ItemClickActionWrapper
        imageOnClickAction={imageOnClickAction}
        openImageZoom={openImageZoomCallback}
        link={link}
        imgAlt={image.alt}
        skinsStyle={skinsStyle}
        translate={translate}
        isFocused={isFocused}
      >
        <ImageSizer
          className={skinsStyle.imageSizer}
          isFitMode={isFitMode}
          imageWidth={image.width}
          imageHeight={image.height}
        >
          <div className={skinsStyle.imageWrapper}>
            <div className={skinsStyle.imageBorder}>
              <Image
                className={skinsStyle.image}
                id={`img_${image.containerId}`}
                {...image}
              />
              <Panel
                skinsStyle={skinsStyle}
                title={title}
                description={description}
              />
            </div>
          </div>
        </ImageSizer>
      </ItemClickActionWrapper>
    </div>
  );
};

export default MatrixGalleryItem;
